module.exports = {"441323001":"平山街道","441323101":"大岭镇","441323102":"白花镇","441323103":"梁化镇","441323104":"稔山镇","441323105":"铁涌镇","441323106":"平海镇","441323109":"吉隆镇","441323110":"黄埠镇","441323113":"多祝镇","441323115":"安墩镇","441323118":"高潭镇","441323120":"宝口镇","441323121":"白盆珠镇","441323450":"广东省惠州市国营惠东梁化林场","441323451":"广东省惠州市国营惠东九龙峰林场","441323452":"惠东县港口海龟湾自然保护区","441323453":"莲花山白盆珠省级自然保护区","441323454":"广东惠东古田省级自然保护区","441323455":"惠东县珠三角产业转移园","441323570":"巺寮滨海旅游渡假区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441323.json
// module id = 1848
// module chunks = 0